// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/checkbox-on.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Average" aria-label="Average" />;
}
